<template>
    <div class="footer_bg">
        <!--    main_footer를 넣으면 위에 줄이 생깁니다.-->
        <div class="content p_footer" :class="{'main_footer' : checkActive('/')}">
            <div class="footer_one">
                <p class="foo_header"> 사단법인 함께하는아버지들</p>
                <p class="foo_p">서울특별시 중구 퇴계로 18길10 호경빌딩 301호</p>
                <p class="foo_p">사업자등록번호: 230-82-00174 <span class="p_span"> 전화:02-415-7955</span>
                    <span class="p_span">mail@fathers.or.kr</span> <span class="p_span">대표 : 김혜준</span>
                </p>
                <p class="foo_p">Copyright 2013. 사단법인 함께하는아버지들 All rights reserved</p>
            </div>
            <div class="footer_two">
                <a href="https://www.nts.go.kr/" target="_blank"><span class="foo_two af"> 국세청</span></a>
                <span class="foo_two af" @click="$router.push('privacy')"> 개인정보 처리방침</span>
                <span class="foo_two" @click="$router.push('term')">서비스이용약관</span>
            </div>
        </div>
        <terms-modal></terms-modal>
    </div>
</template>
<script>

import TermsModal from "@/components/modal/TermsModal";

export default {
    name: 'PageFooter',
    props: {
        msg: String
    },
    components: {TermsModal},
    data() {
        return {}
    },
    mounted() {

    },
    methods: {
        openModal(type) {
            this.$modal.show('terms-modal', {termsType: type});
        },
        checkActive(type) {
            return this.$route.path === type
        },
    },
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>
